module.exports = __webpack_public_path__ + "img/logout.86fa32e3.png";